import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getSearchLimits} from 'src/openapi/admin/apis/GetSearchLimitsApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectSearchLimits} from './services/dictionary-slice';

export const useSearchLimits = () => {
    const apiDispatch = useAppDispatch();
    const searchLimits = useSelector(selectSearchLimits);

    const loadSearchLimits = useCallback(() => {
        if (!searchLimits.length) {
            apiDispatch(getSearchLimits());
        }
    }, [searchLimits.length, apiDispatch]);

    return {searchLimits, loadSearchLimits};
};
